module.exports = [
  'OPEN',
  'IN_PROGRESS',
  'FINISHED',
  'CLOSED',
  'DELETED'
];
